'use strict';

angular.module('esn.contact.libs')
  .constant('CONTACT_EVENTS', {

    UPDATED: 'contact:updated'

  });
